import MikomiData from "./MikomiData";
export default class MikomiMonth
{
    constructor(month, quarter, isQuarter, ishalfYear)
    {
        this.Month = month;
        this.Quarter = quarter;
        this.IsQuarter = isQuarter;
        this.IsHalfYear = ishalfYear;

        this.Keikaku = [];
        this.Estimation = new MikomiData();
        this.Result = new MikomiData();
        this.Difference = new MikomiData();
    }
}